export default {
      id: "logo-usage",
      viewBox: "0 0 98 29",
      url: "../../assets/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }